import Component from './Component';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

 const qs = window.Questions;



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */






/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Tracker extends Component {

    decorator () {
        return {
            selector : '.js-tracker',
            name : 'Tracker',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        this.bindElements();
    }


    cacheElements () {
        this.trackerOption = this.element.querySelector('.js-tracker-option');
    }


    bindElements () {
        if(this.trackerOption) {
            this.trackerOption.addEventListener('change', e => {
                this.toggleTracker(e.target.value);
            })
        }
    }


    toggleTracker (id = 0) {
        if (typeof qs.link == 'undefined') { return; }

        const location = id != 'summary' ? `/application/${qs.slug}/${id}?link=${qs.link}` : `/application/${qs.slug}/summary/${qs.link}`;

        window.location.href = location;
    }

}
